import buildingApi from '@/services/api/building'

const getTeleportBuilding = async markers => {
  const buildingIds = [...new Set(
    markers
      .filter(marker => marker.type === 'teleport')
      .map(marker => marker.nextBuildingId)
  )]

  const reqs = buildingIds.map(buildingId => buildingApi.fetchBuilding(buildingId))
  const buildings = await Promise.all(reqs)
  return buildings.reduce((result, building) => {
    if (building) {
      building.panoramas = building.panoramas || []
      building.panoramas.sort((a, b) => a.index - b.index)
      result[building.objectId] = building
    }
    return result
  }, {})
}

const state = {
  markers: [],
  buildingMarkers: [],
  currentMarker: {},
  musicPlayerRef: null
}
// markers為當前building panorama的markers
export const getters = {
  currentMarker: state => state.currentMarker,
  markers: state => state.markers,
  buildingMarkers: state => state.buildingMarkers
}

export const actions = {
  setMarkers ({ commit, rootState, state }, markers = []) {
    // Make sure to purge previous makers to prevent use old data
    commit('CLEAR_MARKERS')
    const doNotShowTags = rootState.route.query.tags === 'false'
    if (doNotShowTags) markers = markers.filter(marker => marker.type === 'tag')
    if (markers.length) {
      const panoramaId = markers[0].currentPanoramaId
      const markersProcessed = state.buildingMarkers
        .filter(marker => marker.currentPanoramaId === panoramaId)
      commit('SET_MARKERS', markersProcessed)
    } else {
      commit('SET_MARKERS', [])
    }
  },

  async setBuildingMarkers ({ commit }, markers) {
    const buildingInfo = await getTeleportBuilding(markers)
    markers.forEach(marker => {
      if (marker.type === 'teleport') {
        const building = buildingInfo[marker.nextBuildingId]
        if (building) {
          const index = building.panoramas.findIndex(panorama => panorama.objectId === marker.nextPanoramaId)
          marker.teleportPanorama = building.panoramas[index]
          marker.teleportPanoramaIndex = index
        }
      }
    })
    commit('SET_BUILDING_MARKERS', markers)
  },

  setMarker ({ commit }, marker = {}) {
    commit('SET_MARKER', marker)
  },

  setMusicPlayerRef ({ commit }, ref) {
    commit('SET_MUSIC_PLAYER_REF', ref)
  },

  pauseAllVideo ({ rootGetters }) {
    const videos = rootGetters.currentPanorama.markers.filter(marker => marker.type === 'videoplay')
    videos.forEach(marker => {
      window.krpanoObj.call(`hotspot[marker_${marker.objectId}].pause();`)
    })
  },

  pauseMusic ({ state }) {
    if (state.musicPlayerRef) {
      state.musicPlayerRef.pause()
    }
  }
}

export const mutations = {
  SET_MARKERS (state, markers = []) {
    state.markers = markers
  },

  CLEAR_MARKERS (state) {
    state.markers = []
  },

  SET_BUILDING_MARKERS (state, markers = []) {
    state.buildingMarkers = markers
  },

  SET_MARKER (state, marker = {}) {
    state.currentMarker = marker
  },

  SET_MUSIC_PLAYER_REF (state, ref = null) {
    state.musicPlayerRef = ref
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
